import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIncomeSummaryModel } from "../incomeSummaryModel";
import { IIncomeSummaryDetail } from "../incomeSummaryService";
import { formatNum, momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useIncomeSummaryModel();
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<IIncomeSummaryDetail> = [
        {
            title: '月份',
            width: 80,
            align: "center",
            dataIndex: 'day',
            render: (t, r, i) => t !== "13" ? t + "月" : "总计",

        }, {
            title: '销售',
            width: 140,
            dataIndex: 'saleAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '维修服务',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'materialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'workingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '索赔服务',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'claimMaterialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'claimWorkingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`

                },
            ]
        }, {
            title: '保养服务',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'maintainMaterialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'maintainWorkingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '保养合约',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'contractMaterialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'contractWorkingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '事故车服务',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'accidentMaterialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'accidentWorkingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '其他服务',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'otherMaterialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'otherWorkingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '挂车维保',
            align: "center",
            children: [
                {
                    title: '配件',
                    width: 140,
                    align: "center",
                    dataIndex: 'trailerMaterialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '工时',
                    width: 140,
                    align: "center",
                    dataIndex: 'trailerWorkingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '合计',
            width: 140,
            align: "center",
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }
    ];
    return (
        <Table
            bordered
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            scroll={{ x: 'max-content', y: "calc(100vh - 452px)" }
            }
        />
    )
}